import styled from 'styled-components'

import { features } from '@h2/components/media'
import { Page } from '@h2/common/components/page'

const StyledPage = styled(Page)`
  > .Navigator-Dashboard-Layout {
    @media (${features.maxWidth.desktop}) {
      grid-template-areas: 'cnt cnt cnt cnt cnt cnt cnt cnt cnt cnt cnt cnt';
      > .Navigator-Dashboard-SideBar {
        display: none;
      }
    }
  }

  .Navigator-Dashboard-Account {
    @media (${features.minWidth.desktop}) {
      display: none;
    }
  }
`
const LinksRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  gap: 20px;
  flex-wrap: wrap;

  > div {
    @media (${features.minWidth.widescreen}) {
      max-width: calc(50% - 20px);
    }
  }
`
const OverviewRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 20px;
  flex-wrap: wrap;

  > div {
    @media (${features.minWidth.widescreen}) {
      width: calc(50% - 20px);
    }
  }
`

export { StyledPage, LinksRow, OverviewRow }
